import Dexie from 'dexie'
import update from 'immutability-helper'
import { nanoid } from 'nanoid'
import merge from 'lodash.merge'

const JOIN_EXPIRE_INVERVAL = 5 * 60 * 1000
const SESSION_KEY = 'session_key'

const now = () => (new Date().getTime())

const db = new Dexie('YquiDB')

db.version(4)
  .stores({
    settings: 'key',
    join: 'session,name,time'
  })

const storeSettings = async (key, value) => {
  await db.settings.put({ key, value })
}

const retrieveSettings = async key => {
  const record = await db.settings.get(key)
  return record && record.value
}

export const storeUser = async user => {
  await storeSettings('user', user)
}

const defaultUser = {
  name: '',
  chatAnswer: false,
  color: {
    index: 0,
    custom: '#ffffff'
  }
}

export const retrieveUser = async () => {
  const obj = await retrieveSettings('user')
  return merge({}, defaultUser, obj)
}

export const storePersonal = async personal => {
  await storeSettings('personal', personal)
}

const defaultPersonal = {
  display: {
    theme: 'default'
  },
  bind: {
    key: {
      answer: 'Enter'
    },
    gamepad: {
      answer: null,
      correct: null,
      wrong: null,
      through: null,
      reset: null,
      undo: null,
      redo: null
    }
  },
  sound: {
    chat: true,
    roundwin: true,
    timeup: true,
    open: true,
    volume: 100
  }
}

export const retrievePersonal = async () => {
  const obj = await retrieveSettings('personal')
  return merge({}, defaultPersonal, obj)
}

export const storeJoin = async join => {
  await db.join.put(update(join, {
    session: { $set: getSession() },
    time: { $set: now() }
  }))
}

export const retrieveJoin = async () => {
  const join = await db.join.get(getSession())
  if (join) {
    delete join.session
    delete join.time
  }
  return join
}

export const retrieveScoreBackup = async name => {
  await db.join
    .where('time').below(now() - JOIN_EXPIRE_INVERVAL)
    .delete()
  const records = await db.join
    .where('name').equals(name)
    .reverse().sortBy('time')
  const record = records[0]
  return record !== undefined ? record.scoreBackup : null
}

const getSession = () => {
  const session = sessionStorage.getItem(SESSION_KEY)
  if (session) {
    return session
  }

  const newSession = nanoid()
  sessionStorage.setItem(SESSION_KEY, newSession)
  return newSession
}
